const DateRestriction = {
	NONE: "",
	FIXED_LENGTH: "length", // in length
	FIXED_DATE: "date" // utc iso timestamp
};
export default DateRestriction;
